import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ObjectivesView from "../views/ObjectivesView.vue";
import DifferentialsView from "../views/DifferentialsView.vue";
import GalleryView from "../views/GalleryView.vue";
import ServiceListView from "../views/ServiceListView.vue";
import ServiceItemView from "../views/ServiceItemView.vue";
import ArticleListView from "../views/ArticleListView.vue";
import ArticleItemView from "../views/ArticleItemView.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import WorkWithUsView from "../views/WorkWithUsView.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import Error404View from "../views/Error404View.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "",
    path: "/",
    component: HomeView,
  },
  {
    name: "Quem Somos",
    path: "/quem-somos",
    component: AboutView,
  },
  {
    name: "Missão, Visão e Valores",
    path: "/missao-visao-valores",
    component: AboutView,
  },
  {
    name: "Objetivos",
    path: "/objetivos",
    component: ObjectivesView,
  },
  {
    name: "Diferenciais",
    path: "/diferenciais",
    component: DifferentialsView,
  },
  {
    name: "Galeria de Fotos",
    path: "/galeria-de-fotos",
    component: GalleryView,
  },
  {
    name: "Serviços",
    path: "/servicos",
    component: ServiceListView,
  },
  {
    name: "Serviço",
    path: "/servicos/:item",
    component: ServiceItemView,
  },
  {
    name: "Eventos",
    path: "/eventos",
    component: ArticleListView,
  },
  {
    name: "Evento",
    path: "/eventos/:item",
    component: ArticleItemView,
  },
  {
    name: "Contato",
    path: "/contato",
    component: ContactView,
  },
  {
    name: "Obrigado!",
    path: "/contato/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Trabalhe Conosco",
    path: "/trabalhe-conosco",
    component: WorkWithUsView,
  },
  {
    name: "Obrigado!",
    path: "/trabalhe-conosco/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
